// Generated by purs version 0.13.0
"use strict";
var Pressed = (function () {
    function Pressed(value0) {
        this.value0 = value0;
    };
    Pressed.create = function (value0) {
        return new Pressed(value0);
    };
    return Pressed;
})();
var Released = (function () {
    function Released(value0) {
        this.value0 = value0;
    };
    Released.create = function (value0) {
        return new Released(value0);
    };
    return Released;
})();
var Processed = (function () {
    function Processed(value0) {
        this.value0 = value0;
    };
    Processed.create = function (value0) {
        return new Processed(value0);
    };
    return Processed;
})();
var Unpressed = (function () {
    function Unpressed() {

    };
    Unpressed.value = new Unpressed();
    return Unpressed;
})();
module.exports = {
    Pressed: Pressed,
    Released: Released,
    Processed: Processed,
    Unpressed: Unpressed
};
